
import React from 'react';
import BrandLogo from './BrandLogo';

interface PageLoaderProps {
  isLoading: boolean;
}

export const PageLoader: React.FC<PageLoaderProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
      <div className="relative">
        {/* Spinning ring around the logo */}
        <div className="absolute inset-0 w-20 h-20 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
        
        {/* Dialgia Group Icon */}
        <div className="flex items-center justify-center w-20 h-20">
          <BrandLogo 
            variant="icon" 
            size={48} 
            className="animate-pulse-slow" 
          />
        </div>
      </div>
    </div>
  );
};
